let navigationManager = null;
let toastHandler = null;

export const getNavigationManager = () => navigationManager;

export const setNavigationManager = ({ manager, forceUpdate }) => {
  if (navigationManager === null || forceUpdate) {
    navigationManager = manager;
  }
};

export const getToastHandler = () => toastHandler;

export const setToastHandler = ({ handler, forceUpdate }) => {
  if (toastHandler === null || forceUpdate) {
    toastHandler = handler;
  }
};
